import { AxiosRequestConfig } from 'axios';
import { CartStatus } from 'src/items-list/business-logic/service/enumerations/cart-status';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
import { store } from 'src/common/redux/configure-store';

export const callUpdateTransactionStatus = async (cartStatus: CartStatus): Promise<void> => {
  const transactionId: string = store.getState().transaction.transactionId;
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/status/${cartStatus.toLowerCase()}`,
    method: 'PATCH',
    data: {},
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return emeraldRequest<void>(emeraldRequestParams);
};
